import { forwardRef } from "react"
import { useLocalization } from "@tm/localization"
import { NumberField, NumberFieldProps } from "./NumberField"

type MileageFieldProps = Omit<NumberFieldProps, "maxLength" | "isAllowed" | "decimalScale" | "fixedDecimalScale">

export const MileageField = forwardRef<HTMLDivElement, MileageFieldProps>((props, ref) => {
    const { thousandSeparator } = useLocalization()
    return <NumberField ref={ref} {...props} maxLength={9} decimalScale={0} min={0} thousandSeparator={thousandSeparator} />
})
